module.exports = __webpack_public_path__ + "img/empty01.0e15b687.svg";